import { createTheme, ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#517b91',
        },
        secondary: {
            main: '#3fc0ba',
        },
    },
    spacing: 8,
    shape: {
        borderRadius: 4,
    },

    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    color: 'white',
                    fontWeight: 600,
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: 'white',
                    color: '#517b91',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: ({ theme }) => ({
                    marginBottom: '30px',
                    fontWeight: 700,
                    fontSize: '38px',
                    [theme.breakpoints.up('sm')]: {
                        fontSize: '38px',
                    },
                    [theme.breakpoints.up('md')]: {
                        fontSize: '48px',
                    },
                    [theme.breakpoints.up('lg')]: {
                        fontSize: '54px',
                    },
                }),
                h2: ({ theme }) => ({
                    marginBottom: '15px',
                    fontWeight: 600,
                    fontSize: '28px',
                    [theme.breakpoints.up('sm')]: {
                        fontSize: '30px',
                    },
                    [theme.breakpoints.up('md')]: {
                        fontSize: '36px',
                    },
                    [theme.breakpoints.up('lg')]: {
                        fontSize: '42px',
                    },
                }),
                h3: ({ theme }) => ({
                    marginBottom: '12px',
                    fontWeight: 600,
                    fontSize: '22px',
                    [theme.breakpoints.up('sm')]: {
                        fontSize: '24px',
                    },
                    [theme.breakpoints.up('md')]: {
                        fontSize: '28px',
                    },
                    [theme.breakpoints.up('lg')]: {
                        fontSize: '32px',
                    },
                }),
            },
        },
    },
};

export const theme = createTheme(themeOptions);
